var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalSell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 709.5,
    viewBox: "0 0 960 709.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-494 -229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M681.639,356.172H528.951a17.817,17.817,0,0,1-17.8-17.8V255.213a17.816,17.816,0,0,1,17.8-17.8H681.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(356.636 90.929)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.509,75.91l1.965-14.174A31.717,31.717,0,1,1,48.536,58.6L50.69,75.91Z",
    transform: "translate(883.212 397.399)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.4,746.153H316.409a1.436,1.436,0,0,1,0-2.847H910.4a1.436,1.436,0,0,1,0,2.847Z",
    transform: "translate(473.513 189.8)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.114,722.122s2.76,29.443,1.84,34.957-28.52-.924-28.52-.924c4.6-9.2,7.361-36.8,7.361-36.8Z",
    transform: "translate(596.573 154.459)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.049,744.2s4.051-6.479,4.051-4.051,10.531,8.915,10.531,8.915,10.531-1.621,12.152,10.531-14.582,14.581-18.631,13.77-14.582.814-14.582.814a72.3,72.3,0,0,1-21.061,0c-12.961-1.621-1.621-23.49,0-27.542s9.721-.813,9.721-.813C350.809,749.868,354.049,744.2,354.049,744.2Z",
    transform: "translate(598.067 163.55)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.887,719.985s1.773,20.387.89,25.7-27.479-.89-27.479-.89c4.432-8.863,7.092-35.455,7.092-35.455Z",
    transform: "translate(627.933 162.1)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.156,196.228H203.792a5.324,5.324,0,0,1-5.318-5.318V159.63a5.323,5.323,0,0,1,5.318-5.318h949.365a5.323,5.323,0,0,1,5.318,5.318v31.28A5.323,5.323,0,0,1,1153.156,196.228Z",
    transform: "translate(295.526 74.687)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.55,
    cy: 7.55,
    r: 7.55,
    transform: "translate(517.311 240.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.55,
    cy: 7.55,
    r: 7.55,
    transform: "translate(545.968 240.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.55,
    cy: 7.55,
    r: 7.55,
    transform: "translate(574.625 240.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.385,167.02h-33a2.444,2.444,0,0,1,0-4.889h33a2.444,2.444,0,1,1,.009,4.889Z",
    transform: "translate(441.219 76.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.385,174.688h-33a2.444,2.444,0,0,1,0-4.889h33a2.444,2.444,0,1,1,.009,4.889Z",
    transform: "translate(441.219 77.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.385,182.356h-33a2.444,2.444,0,0,1,0-4.889h33a2.444,2.444,0,1,1,.009,4.889Z",
    transform: "translate(441.219 79.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.524,668.834a9.467,9.467,0,0,0,7.438,5.038c.8.079.572,1.306-.223,1.228a10.609,10.609,0,0,1-8.24-5.555.645.645,0,0,1,.158-.868.627.627,0,0,1,.868.158Z",
    transform: "translate(356.683 175.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.639,356.172H333.951a17.817,17.817,0,0,1-17.8-17.8V255.213a17.816,17.816,0,0,1,17.8-17.8H486.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(318.525 90.929)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.639,356.172H723.951a17.817,17.817,0,0,1-17.8-17.8V255.213a17.816,17.816,0,0,1,17.8-17.8H876.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(394.747 90.929)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.639,511.172H333.951a17.817,17.817,0,0,1-17.8-17.8V410.213a17.816,17.816,0,0,1,17.8-17.8H486.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(318.525 121.222)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.639,511.172H528.951a17.817,17.817,0,0,1-17.8-17.8V410.213a17.816,17.816,0,0,1,17.8-17.8H681.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(356.636 121.222)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1021.785 593.155)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.271,
    cy: 27.271,
    r: 27.271,
    transform: "translate(0 0)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.36,481.7h-9.272V472.43a2.182,2.182,0,0,0-2.182-2.182h0a2.182,2.182,0,0,0-2.182,2.182V481.7h-9.272a2.182,2.182,0,0,0-2.182,2.182h0a2.182,2.182,0,0,0,2.182,2.182h9.272v9.272a2.182,2.182,0,0,0,2.182,2.182h0a2.182,2.182,0,0,0,2.182-2.182v-9.272h9.272a2.182,2.182,0,0,0,2.182-2.182h0a2.182,2.182,0,0,0-2.182-2.182h0Z",
    transform: "translate(-637.765 -456.722)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1258.482 412.644)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.271,
    cy: 27.271,
    r: 27.271,
    transform: "translate(0 0)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.36,330.7h-9.272V321.43a2.182,2.182,0,0,0-2.182-2.182h0a2.182,2.182,0,0,0-2.182,2.182V330.7h-9.272a2.182,2.182,0,0,0-2.182,2.182h0a2.182,2.182,0,0,0,2.182,2.182h9.272v9.272a2.182,2.182,0,0,0,2.182,2.182h0a2.182,2.182,0,0,0,2.182-2.182v-9.272h9.272a2.182,2.182,0,0,0,2.182-2.182h0a2.182,2.182,0,0,0-2.182-2.182h0Z",
    transform: "translate(-835.765 -305.722)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(788.675 410.253)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.271,
    cy: 27.271,
    r: 27.271,
    transform: "translate(0)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.36,328.7h-9.272V319.43a2.182,2.182,0,0,0-2.182-2.182h0a2.182,2.182,0,0,0-2.182,2.182h0V328.7h-9.272a2.182,2.182,0,0,0-2.182,2.182h0a2.182,2.182,0,0,0,2.182,2.182h9.272v9.272a2.182,2.182,0,0,0,2.182,2.182h0a2.182,2.182,0,0,0,2.182-2.182v-9.272h9.272a2.182,2.182,0,0,0,2.182-2.182h0a2.182,2.182,0,0,0-2.182-2.182h0Z",
    transform: "translate(-442.765 -303.722)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M645.45,298.466A10.842,10.842,0,0,1,636.7,312.6l-12.61,86.073-20.685-10.1,20.805-85.917a10.9,10.9,0,0,1,21.241-4.189Z",
    transform: "translate(374.665 101.386)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.829,545.431a10.842,10.842,0,0,0-4.175-16.093l8.507-91.554-17.818,9.133-5.564,88.225a10.9,10.9,0,0,0,19.049,10.289Z",
    transform: "translate(353.677 130.089)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,348.246l76.461-2.941,4.411-79.4H318.148Z",
    transform: "translate(556.178 280.968)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.693,474.283s-22.878,18.47-10.476,84.432c-1.889.225.25,3.948.25,3.948L497.281,746.354l46.061,4,29.4-212.778-5.926,212.778h38.95l8.509-140.532,9.461-51.939s2.854-40.6-17.97-88.366Z",
    transform: "translate(353.925 136.291)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.087,154.875,0,147.108S3.2,91.345,8.183,66.7c2.186-10.825,8.989-18,15.931-22.639a26.076,26.076,0,0,1,7.763-4.271c1.6-.719,3.109-1.307,4.445-1.78L48.064,22.65l.239,0,38.924.517L99.859,39.213l12.593,2.971c2.888-1,7.531-1.977,14.877-2.262.676-.024-.159-1.364-.159-1.364L135.059,0l26.286,14.555-4.438,40.424L116.62,100.8c-.636,1.052-1.29,2.153-1.957,3.31l2.12,35.187.961,1.746a4.729,4.729,0,0,1-1.133,5.937,9.236,9.236,0,0,1,.126,5.706l-.5,1.65c0,.047-.134.718-1.209,1.536-1.944,1.478-7.528,3.728-23.415,3.728-12.377,0-31.005-1.364-59.051-5.529a8.515,8.515,0,0,1-1.755-.458l-1.768,7.743Z",
    transform: "translate(847.886 444.536)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.835,296.87c-11.184-7.692-21.034-8.864-29.124-6.682-1.049-1.622-19.4,9.2-17.4,11.922-4.361,5.464-6.736,11.373-6.736,14.911-9.061,16.56-14.93,56.638,1.63,65.7,6.605,3.633,33.058-20.891,40.5-22.075l.693-2.958.939,2.664,3.133,8.931q5.422,2.623,10.751,5.751c-1.35-6.338-2.441-12.663-3.193-18.848-1.04-8.418,2.586-20.951,5.2-28.572a44.988,44.988,0,0,0,2.463-14.6V312.8l2.547,8.18,9.272-3.955C593.79,307.128,595.515,295.9,574.835,296.87Z",
    transform: "translate(356.942 101.052)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.271,
    cy: 27.271,
    r: 27.271,
    transform: "translate(785.557 596.739)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1059.695 677.301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.5,100.653H15.084A15.1,15.1,0,0,1,0,85.569V15.084A15.1,15.1,0,0,1,15.084,0H144.5a15.1,15.1,0,0,1,15.084,15.084V85.568A15.1,15.1,0,0,1,144.5,100.653Z",
    transform: "translate(252.71 0) rotate(68)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,100.653H15.084A15.1,15.1,0,0,1,0,85.569V15.084A15.1,15.1,0,0,1,15.084,0H144.5a15.1,15.1,0,0,1,15.084,15.084V85.568A15.1,15.1,0,0,1,144.5,100.653Z",
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 105.216, 16.246)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20.865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M788.957,539.695c-1.679,0-3.04-2.895-3.04-6.466V429.43c0-3.571,1.361-6.466,3.04-6.466s3.04,2.895,3.04,6.466v103.8c0,3.572-1.361,6.466-3.04,6.466Z",
    transform: "translate(-675.964 -369.079)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.038,533.666c-1.679,0-3.04-2.895-3.04-6.466V432.023c0-3.571,1.361-6.466,3.04-6.466s3.04,2.9,3.04,6.466V527.2c0,3.571-1.361,6.466-3.039,6.466Z",
    transform: "translate(-580.452 -363.049)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.038,533.666c-1.679,0-3.04-2.895-3.04-6.466V432.023c0-3.571,1.361-6.466,3.04-6.466s3.04,2.9,3.04,6.466V527.2c0,3.571-1.361,6.466-3.039,6.466Z",
    transform: "translate(-648.92 -363.049)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.777,
    cy: 10.777,
    rx: 10.777,
    ry: 10.777,
    transform: "translate(4.861 213.387)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.777,
    cy: 10.777,
    rx: 10.777,
    ry: 10.777,
    transform: "translate(273.737 213.387)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.754,479.977H759.48a6.466,6.466,0,0,1,0-12.933h288.274a6.466,6.466,0,0,1,0,12.932Z",
    transform: "translate(-752.464 -266.591)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.407,504.526a6.44,6.44,0,0,1-4.211-1.562l-42.5-36.524a6.466,6.466,0,0,1,8.428-9.809l42.5,36.524a6.466,6.466,0,0,1-4.217,11.371Z",
    transform: "translate(-711.943 -294.433)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1018.855,579.839H799.615a35.137,35.137,0,0,1-35.1-35.1V413.872a6.466,6.466,0,1,1,12.932,0V448.92l254.66,23.15a19.421,19.421,0,0,1,19.077,19.4,6.494,6.494,0,0,1-.111,1.193L1038.242,561.1A19.42,19.42,0,0,1,1018.855,579.839ZM777.449,461.905v82.836a22.191,22.191,0,0,0,22.166,22.164h219.24a6.473,6.473,0,0,0,6.466-6.466,6.456,6.456,0,0,1,.111-1.191l12.8-68.282a6.474,6.474,0,0,0-6.447-5.967c-.2,0-.391-.008-.585-.027Z",
    transform: "translate(-725.72 -405.25)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.355,419.69H759.314a6.466,6.466,0,0,1,0-12.932h56.041a6.466,6.466,0,0,1,0,12.932Z",
    transform: "translate(-752.848 -406.757)",
    fill: "#7C3AED"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M876.639,356.172H723.951a17.817,17.817,0,0,1-17.8-17.8V255.213a17.816,17.816,0,0,1,17.8-17.8H876.639a17.816,17.816,0,0,1,17.8,17.8v83.161a17.817,17.817,0,0,1-17.8,17.8Z",
    transform: "translate(394.747 275.023)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.691,734.159s4.024-6.438,4.024-4.024,10.463,8.857,10.463,8.857,10.461-1.61,12.071,10.461-14.487,14.485-18.509,13.677-14.485.808-14.485.808a71.806,71.806,0,0,1-20.921,0c-12.875-1.61-1.61-23.335,0-27.36s9.656-.808,9.656-.808C250.472,739.791,253.691,734.159,253.691,734.159Z",
    transform: "translate(628.625 169.806)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.271,
    cy: 27.271,
    r: 27.271,
    transform: "translate(1261.912 596.739)",
    fill: "#e6e6e6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalSell);
export default __webpack_public_path__ + "static/media/goal-sell.30a9e68f15074f2ec2546bd9bc6bcbcd.svg";
export { ForwardRef as ReactComponent };